<template>
  <div class="register-wrap">
    <div class="logo">
      <img src="../assets/logo.png" alt />
    </div>
    <div class="input-panel">
      <div class="input-box">
        <p class="label">手机号码</p>
        <div class="input">
          <span>+86</span>
          <input type="text" placeholder="请输入你的手机号" v-model="registerForm.mobile" maxlength="11" />
        </div>
      </div>
      <div class="input-box">
        <p class="label">用户名称</p>
        <div class="input">
          <input type="text" placeholder="请输入用户名称" v-model="registerForm.name" />
        </div>
      </div>
      <div class="input-box">
        <p class="label">注册类型</p>
        <div class="input">
          <!--<select type="text" style="padding: 0;" v-model="registerForm.toType">-->
            <!--<option :value="1">学生</option>-->
            <!--<option :value="2">教师</option>-->
            <!--<option :value="3">机构人员</option>-->
          <!--</select>-->
          <input type="text" v-model="registerForm.toType" style="display: none" @click="show = true">
          <input type="text" v-model="pickerText" readonly @click="show = true">
          <van-icon name="arrow-down" style="line-height: 46px" />
        </div>
      </div>
      <div class="input-box">
        <p class="label">验证码</p>
        <div class="input">
          <input
            type="text"
            placeholder="请输入验证码"
            v-model="registerForm.captcha"
            maxlength="6"
          />
          <div class="yzm-btn" @click="getAuthCode">{{isSend ? `${seconds}秒后重新获取` : '获取验证码'}}</div>
        </div>
      </div>
      <div class="register-btn" @click="register">立即注册</div>
      <div class="proto" @click="checked = !checked">
        <i :class="checked ? 'check-box active' : 'check-box'"></i>点击 下一步 即表示您已阅读并同意<a href="#/agreement/0">《用户协议》</a>
      </div>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-picker
              show-toolbar
              title="注册类型"
              :columns="columns"
              @cancel="onCancel"
              @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { PATTERN_MOBILE, PATTERN_AUTHCODE } from "../config/common";
import { getAuthCode, register } from "../services/api";

export default {
  name: "Register",
  data() {
    return {
      checked: false,
      registerForm: {
        captcha: "",
        fromId: "",
        fromType: "",
        mobile: "",
        password: "123456",
        toType: 1,
        name: '',
      },
      seconds: 60,
      isSend: false,
      timer: undefined,
      show: false,
      pickerText: '学生',
      columns: [
        {
          text: '学生',
          value: 1,
        },
        {
          text: '教师',
          value: 2,
        },
        // {
        //   text: '机构人员',
        //   value: 3,
        // },
      ]
    };
  },
  mounted() {
    const { params } = this.$route;
    this.registerForm.fromId = params.fromId * 1;
    this.registerForm.fromType = params.fromType * 1;
  },
  methods: {
    getAuthCode() {
      if (this.isSend) {
        return;
      }
      if (!this.validMobile()) {
        return;
      }
      getAuthCode(this.registerForm.mobile).then(() => {
        this.isSend = true;
        this.countTimer();
      });
    },
    validMobile() {
      const mobile = this.registerForm.mobile;
      if (!PATTERN_MOBILE.test(mobile)) {
        this.$notify({ type: "warning", message: "请输入正确的手机号" });
        return false;
      }
      return true;
    },
    validCode() {
      if (!PATTERN_AUTHCODE.test(this.registerForm.captcha)) {
        this.$notify({ type: "warning", message: "请输入正确的验证码" });
        return false;
      }
      return true;
    },
    register() {
      if(!this.registerForm.name){
        this.$notify({ type: "warning", message: "请输入用户姓名" });
        return;
      }
      if (!this.validMobile() || !this.validCode()) {
        return;
      }
      if (!this.checked) {
        this.$notify({ type: "warning", message: "请先同意协议" });
        return;
      }
      this.$toast.loading({
        mask: true,
				message: "加载中...",
				duration: 0,
      });
      register(this.registerForm).then(json => {
				this.$toast.clear();
        this.$router.replace("/success/"+this.registerForm.toType);
      }).catch(() => {
				this.$toast.clear();
			});
    },
    countTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        if (this.seconds < 1) {
          clearInterval(this.timer);
          this.isSend = false;
          this.seconds = 60;
          return;
        }
        this.seconds--;
      }, 1000);
    },
    onCancel() {
      this.show = false;
    },
    onConfirm(e) {
      this.registerForm.toType = e.value;
      this.pickerText = e.text;
      this.show = false;
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style scoped lang="scss">
.register-wrap {
  min-height: 100%;
  height: auto;
  padding: 52px 34px;
  box-sizing: border-box;

  .logo {
    text-align: center;
    margin-bottom: 42px;

    img {
      width: 120px;
      height: 35px;
    }
  }

  .input-panel {
    .input-box {
      .label {
        font-size: 12px;
        color: #384049;
      }

      .input {
        display: flex;
        border-bottom: 1px solid #cccccc;
        margin-bottom: 28px;
        
        input{
          line-height: 24px;
          padding: 2px 0px;
        }
        span {
          position: relative;
          line-height: 46px;
          padding-right: 13px;
          font-size: 17px;

          &::after {
            content: " ";
            position: absolute;
            width: 1px;
            height: 17px;
            right: 0;
            top: 14px;
            background-color: #cbccd2;
          }
        }

        input,
        select {
          outline: none;
          border: none;
          flex: 1;
          padding-left: 13px;
          font-size: 17px;
        }

        .yzm-btn {
          border: 1px solid #4680fa;
          color: #4680fa;
          border-radius: 30px;
          text-align: center;
          font-size: 12px;
          padding: 10px 16px;
          flex: none;
          margin-bottom: 10px;
        }
      }
    }

    .register-btn {
      background-color: #4680fa;
      color: #fff;
      border-radius: 5px;
      text-align: center;
      height: 45px;
      line-height: 45px;
      margin-top: 50px;
    }

    .proto {
      font-size: 12px;
      color: #858d97;
      margin-top: 18px;

      .check-box {
        position: relative;
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 15px;
        border: 1px solid #e0e0e0;
        margin-right: 5px;
        vertical-align: middle;

        &::before {
          position: absolute;
          content: " ";
          width: 8px;
          height: 5px;
          border-left: 2px solid #fff;
          border-bottom: 2px solid #fff;
          left: 3px;
          top: 3px;
          transform: rotate(-45deg);
        }

        &.active {
          background-color: #4680fa;
          border: 1px solid #4680fa;
        }
      }
    }
  }
}
</style>
